import * as contentSession from './contentSession'
import * as speaker from './speaker'
import * as home from './home'
import * as series from './series'
import * as calendar from './calendar'
import * as expohall from './expohall'
import * as speakers from './speakers'
import * as virtualBooth from './virtualBooth'
import * as myPlaylist from './myPlaylist'
import * as search from './search'
import * as vendors from './vendors'
import * as sponsorHighlights from './sponsorHighlights'
import * as faq from './faq'

export default {
  contentSession,
  speaker,
  home,
  series,
  calendar,
  expohall,
  speakers,
  virtualBooth,
  myPlaylist,
  search,
  vendors,
  sponsorHighlights,
  faq,
}
